import React from 'react';
import PropTypes from 'prop-types';
import dropRight from 'lodash/dropRight';
import takeRight from 'lodash/takeRight';
import head from 'lodash/head';

import { trans } from '@spotahome/bff/client';

import './ShowApartmentNumber.scss';

const ShowApartmentNumber = ({ number }) => {
  const roomsLength = number.length;
  const roomsNumber = number
    .sort()
    .map(
      filter =>
        filter === '4more' ? trans('search.filter.more_than_4') : filter
    );

  const groupFirst = dropRight(roomsNumber).join(', ');
  const last = takeRight(roomsNumber);

  const showRooms = () =>
    roomsLength === 1
      ? trans(
          Number(head(roomsNumber)) === 1
            ? 'search.filter.show_apartment_single'
            : 'search.filter.show_apartment_plural',
          {
            number: roomsNumber
          }
        )
      : trans('search.filter.show_apartments', {
          number: groupFirst,
          last
        });

  return (
    <span className="show-apartments-text">
      {roomsLength === 0 ? trans('search.filter.any_rooms') : showRooms()}
    </span>
  );
};

ShowApartmentNumber.defaultProps = {
  number: []
};

ShowApartmentNumber.propTypes = {
  number: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  )
};

export default ShowApartmentNumber;
